/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { S3UploadItemMapper } from '@gh/common-shared-data';
import { arrayOf, entity } from '@gh/core-data';
import { FormulaMapper } from '../common';
import { ComponentDetailsDto, ComponentItemDto } from './component-details.dto';

export const ComponentItemMapper = entity<ComponentItemDto>();

export const ComponentDetailsMapper = entity<ComponentDetailsDto>({
  formula: FormulaMapper,
  picture: S3UploadItemMapper,
  items: arrayOf(ComponentItemMapper),
});
